<template lang="pug">
  div.module-property
    div.md-layout(v-if="!input.multiply")
      div.md-layout-item.inline-field(v-if="input.type != 'radio' && (['textarea', 'text', 'number'].indexOf(input.type) + 1)")
        label.left-label {{ input.name }}
        md-field
          //label(v-bind:for="input.code" v-if='(input.name && input.type != "checkbox" && input.type != "radio")') {{input.name}}
          md-input(v-if='(input.type == "text")' v-bind:name="input.code" v-bind:id="input.code"  v-model="inputValue" v-bind:placeholder="input.placeholder")
          md-input(v-if='(input.type == "number")' v-bind:name="input.code" v-bind:id="input.code" v-model="inputValue" type="number" v-bind:placeholder="input.placeholder")
          md-textarea(v-if='(input.type == "textarea")' v-bind:name="input.code" v-bind:id="input.code"  v-model="inputValue" v-bind:placeholder="input.placeholder")
          md-icon(v-if="input.help") help_outline
            md-tooltip(md-direction="top") {{input.help}}
          md-button.saved-button.md-dense(disabled v-show="savedSuccess") Сохранено
          md-button.deleted-button.md-dense(disabled v-show="deleteSuccess") Удалено
          md-button.md-icon-button.md-dense(@click="saveValue()" v-if="!inputProgress"): md-icon done
          md-button.md-icon-button.md-dense(@click="clearValue()" v-if="!inputProgress"): md-icon close

      div(v-if="input.type == 'checkbox'")
        label {{input.name}}
        div
          md-switch(v-model="inputValue") {{input.name}}
          md-button.saved-button.md-dense(disabled v-show="savedSuccess") Сохранено

      div.md-layout-item.inline-field(v-if="input.type == 'select'")
        label.left-label {{ input.name }}
        md-field
          //label(v-if="input.name" "input.code") {{input.name}}
          md-select(v-model="inputValue" v-bind:name="input.code" v-bind:id="input.code" v-bind:placeholder="input.placeholder")
            md-option(v-for="(value, key) in input.values" v-bind:key="key" v-bind:value="key") {{value}}
          md-icon(v-if="input.help") help_outline
            md-tooltip(md-direction="top") {{input.help}}
          md-button.saved-button.md-dense(disabled v-show="savedSuccess") Сохранено

      div(v-if="input.type == 'radio'")
        label(v-if="input.name" v-bind:for="input.code") {{input.name}}
        div
          md-radio(v-for="(value, key) in input.values" v-model="inputValue" v-bind:key="key" v-bind:value="key" v-bind:id="input.code" ) {{value}}
          md-button.saved-button.md-dense(disabled v-show="savedSuccess") Сохранено

    div
      div(v-if="input.multiply && input.type == 'checkbox'")
        label(v-if="input.name" v-bind:for="input.code") {{input.name}}
          div
            md-checkbox(v-for="(value, key) in input.values" v-bind:key="key" v-if='input.type == "checkbox"' v-model="inputValueMultiply" v-bind:value="key") {{value}}
            md-button.saved-button.md-dense(disabled v-show="savedSuccess") Сохранено

      div.md-layout-item(v-if="input.multiply && input.type == 'select'")
        md-field
          label(v-if="input.name" v-bind:for="input.code") {{input.name}}
          md-select(v-model="inputValueMultiply" v-bind:name="input.code" v-bind:id="input.code" multiple v-bind:placeholder="input.placeholder")
            md-option(v-for="(value, key) in input.values" v-bind:key="key" v-bind:value="key") {{value}}
          md-button.saved-button.md-dense(disabled v-show="savedSuccess") Сохранено

    div.md-layout(v-if="input.type == 'file'")
      div.file-container(v-if="!input.multiply")
        div.md-layout-item
          md-field
            label(v-bind:for="input.code" v-if='(input.name)') {{input.name}}
            md-file(v-bind:name="input.code" v-bind:id="input.code"  v-model="inputValue" v-bind:placeholder="input.placeholder" @md-change="changeFile")
            md-progress-spinner(md-mode="indeterminate" v-bind:md-diameter="30" v-bind:md-stroke="3" v-if="inputProgress")
            md-button.md-icon-button.md-dense(@click="saveValue()" v-if="inputValue && file && inputValue != file.path && !inputProgress"): md-icon done
            md-button.md-icon-button.md-dense(@click="clearValue()" v-if="!inputProgress"): md-icon close
        md-card.image-container(v-if="Object.keys(file).length && inputValue")
          md-card-media(md-ratio="16:9")
            img(v-bind:src="file.path")
          md-card-area
            md-card-header
              div.md-title {{file.name}}
              span.md-subhead {{file.size}}
              span.md-subhead {{', Формат: ' + file.file_type}}
              div.md-subhead(v-if="file.uploader") {{'Загрузил: ' + file.uploader.login + ' (' + moment(this.file.created_at).format('DD.MM.YYYY HH:mm:ss') + ')' }}
            md-card-actions(v-if="!inputProgress")
              span
                md-button.md-icon-button.md-dense(@click="openFile(inputValue)"): md-icon loupe
                md-tooltip(md-direction="top" md-delay="300") {{openFileTooltip}}
              span(v-if="inputValue != file.path")
                md-button.md-icon-button.md-dense(@click="saveValue()"): md-icon done
                md-tooltip(md-direction="top" md-delay="300") {{saveFileTooltip}}
              span
                md-button.md-icon-button.md-dense(@click="clearValue()"): md-icon close
                md-tooltip(md-direction="top" md-delay="300") {{deleteFileTooltip}}

</template>

<script>
  export default {
    name: 'module-property',
    props: [
      'property',
      'module' //код модуля, свойства которого, будут сохраняться. используется в случае, если компонент вызывается не на странице настройки модуля
    ],
    data() {
      return {
        input: (this.props && property) ? this.props.property : {},
        file: {},
        inputValue: false,
        inputValueMultiply: [],
        openFileTooltip: 'Открыть файл в новой вкладке',
        saveFileTooltip: 'Сохранить файл',
        deleteFileTooltip: 'Удалить файл',
        inputProgress: false,
        savedSuccess: false,
        deleteSuccess: false,
        changeTime: false
      }
    },
    watch: {
      'inputValue'(newVal, oldVal) {
        if ((['radio', 'checkbox', 'select'].indexOf(this.input.type) + 1) && oldVal) {
          this.saveValueAfterDelay();
        }
      },
      'inputValueMultiply'(newVal, oldVal) {
        if ((['radio', 'checkbox', 'select'].indexOf(this.input.type) + 1) && Object.keys(oldVal).length) {
          this.saveValueAfterDelay();
        }
      }

    },
    computed: {

    },
    created() {
      this.input = this.property;

      if (!this.input.multiply) {
        this.inputValue = this.input.value || this.input.default_value;
      } else {
        this.inputValueMultiply = this.input.value || this.input.default_value;
      }
      if (this.input.type == 'file' && this.input.value) {
        this.inputValue = this.input.value.path || this.input.default_value;
        this.file = this.input.value;
      }
    },
    methods: {
      changeFile(fileList){
        if (Object.keys(fileList).length) {
          this.fileObj = Object.assign(fileList[0]);
        }
      },
      openFile(url) {
        let win = window.open(url, '_blank');
        win.focus();
      },
      clearValue() {
        this.inputProgress = true;
        this.$store.dispatch('module/removeModulePropertyValue', this.input.code).then(response => {
          this.inputValue = '';
          this.inputValueMultiply = [];
          if (this.input.type == 'file') {this.file = {};}
          this.inputProgress = false;
          this.setDeleteMessage();
        }, response => {
          this.inputProgress = false;
        });

      },
      saveValue(){
        this.inputProgress = true;
        let data;
        if (this.input.type != 'file') {
          data = {
            module_name: this.module || this.$route.params.code,
            prop_code: this.input.code,
            value: (this.input.multiply) ? this.inputValueMultiply : this.inputValue
          };
        } else {
          data = new FormData();
          data.append('module_name', this.$route.params.code);
          data.append('prop_code', this.input.code);
          data.append('value', this.fileObj);
        }

        this.$store.dispatch('module/setModulePropertyValue', data).then(response => {
          if (response.status == 200) {
            if (this.input.type == 'file') {
              this.inputValue = response.body.response.value.path;
              this.file = response.body.response.value;
            }
          }
          this.inputProgress = false;
          this.setSuccessMessage();
        }, response => {
          this.inputProgress = false;
        });
      },
      //запускает автосохранение сохранение для полей radio, checkbox, select
      saveValueAfterDelay(){
        let that = this;
        this.changeTime = this.moment().format('x');
        setTimeout(function () {
          //если в течении 3 секунд это значение не изменялось, то сохраняем его
          //сделано это потому что пользователь может кликать по чекбоксам по 20 раз,
          //а слать столько запросов на сервер каждый раз меняя одно значение - плохо
          if ( (that.moment().format('x') - that.changeTime) >= 3000 ) {
            that.saveValue();
          }
        }, 3000);

      },
      //показывает сообщение о успешном сохранении
      setSuccessMessage() {
        this.savedSuccess = true;let that = this;
        setTimeout(function () {that.savedSuccess = false;}, 3000);
      },
      //показывает сообщение о успешном удалении
      setDeleteMessage() {
        this.deleteSuccess = true;let that = this;
        setTimeout(function () {that.deleteSuccess = false;}, 3000);
      },

    }
  }
</script>
<style scoped lang="sass">
  .module-property
    .inline-field
      display: flex
      align-items: center
      justify-content: flex-start
      .md-field
        margin: 0px 0px 0px 0px !important
        padding-top: 0px
        min-height: 32px
        label
          top: 10px
      .left-label
        flex-shrink: 0
        margin-right: 10px
        max-width: 50%
    .saved-button
      color: #155724
      background-color: #d4edda
      border-color: #c3e6cb
      margin: 0px 6px 0px 0px
    .deleted-button
      color: #721c24
      background-color: #f8d7da
      border-color: #f5c6cb
      margin: 0px 6px 0px 0px
    .md-checkbox, .md-radio
      display: flex
    .file-container
      width: 100%
      margin: 0 0 24px 0
      .image-container
        display: table
        position: relative
        max-width: 300px
        overflow: hidden
        img
          display: block
          max-width: 100%
</style>



// WEBPACK FOOTER //
// ModulePtoperty.vue?eaa7dd3e